import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import React from "react";
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import { i18n } from "../../translate/i18n";

type Props = {
  show: boolean;
  close: () => void;
};

const ServiceCreationBlockedModal: React.FC<Props> = ({ show, close }) => {
  return (
    <Dialog
      maxWidth="xs"
      fullWidth
      open={show}
      onClose={close}
    >
      <DialogTitle sx={{ textAlign: 'left' }}>
        {i18n.t('serviceCreationBlockedModal.title') as string}
      </DialogTitle>

      <DialogContent dividers>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <WarningAmberRoundedIcon fontSize="large" color="warning" />
          </Box>
          <Typography sx={{ fontSize: 16, fontWeight: 500, textAlign: 'left' }}>
            {i18n.t('serviceCreationBlockedModal.text') as string}
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions>
        <Button variant="contained" onClick={close} color="primary">
          {i18n.t('serviceCreationBlockedModal.okButton') as string}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ServiceCreationBlockedModal;
